<template>
    <div>
    </div>
</template>

<script>
    export default {
        name: "subscription-purchase-auto",
        props: ['csrf_token', 'order_site', 'pay_kind', 'json_characters'],
        mounted() {
            this.characters = JSON.parse(this.json_characters);
            axios.default
                .get('/subscription/info/get')
                .then(response => {
                    let ret = response.data;
                    let item_id = ret[0].item_id;
                    this.pay(this.pay_kind, item_id);
                });
        },
        methods: {
            pay: function(pay_kind, item_id) {
                axios.default
                    .post('/subscription/purchase/pay', {pay_kind: pay_kind, item_id: item_id})
                    .then(response => {
                        let data = response.data;
                        if(data['err']) {
                            alert(this.characters[data['err']]);
                            if(data['err']=='credit_unregist') {
                                location.href='/credit/regist?status=purchase';
                            } else {
                                location.href='/subscription/purchase';
                            }
                        } else {
                            location.href='/subscription/purchase/end';
                        }
                    });
            },
        }
    }
</script>

<style scoped>
</style>
